import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = { class: "flex items-center" }
const _hoisted_3 = { class: "flex items-center text-gray-700" }
const _hoisted_4 = { class: "w-40 sm:w-44 truncate font-light" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_svg_icon = _resolveComponent("base-svg-icon")!
  const _component_base_accordion_open_icon = _resolveComponent("base-accordion-open-icon")!
  const _component_layout_auth_sidebar_content_submenu = _resolveComponent("layout-auth-sidebar-content-submenu")!

  return (_openBlock(), _createElementBlock("ul", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menus, (menu, index) => {
      return (_openBlock(), _createElementBlock("li", {
        key: menu.id
      }, [
        _createElementVNode("div", {
          onClick: ($event: any) => (_ctx.validateUrl(menu.url) ? _ctx.externalOrInternalLink(menu.url, menu.open) : _ctx.handleToggle(index)),
          class: _normalizeClass(["flex items-center justify-between cursor-pointer hover:bg-gray-200 w-full px-4 py-2", [menu.url === _ctx.currentUrl ? 'bg-blue-200': '']])
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_base_svg_icon, {
              class: "w-5 mr-2",
              path: menu.icon
            }, null, 8, ["path"]),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, _toDisplayString(menu.title), 1),
              (_ctx.validateUrl(menu.url) === _ctx.LINK_STATUS.external)
                ? (_openBlock(), _createBlock(_component_base_svg_icon, {
                    key: 0,
                    class: "w-4",
                    path: _ctx.mdiOpenInNew
                  }, null, 8, ["path"]))
                : _createCommentVNode("", true)
            ])
          ]),
          (!_ctx.validateUrl(menu.url) && _ctx.toArray(menu.menu_subs).length)
            ? (_openBlock(), _createBlock(_component_base_accordion_open_icon, {
                key: 0,
                isOpen: _ctx.isOpenSubmenu[index]
              }, null, 8, ["isOpen"]))
            : _createCommentVNode("", true)
        ], 10, _hoisted_1),
        (!_ctx.validateUrl(menu.url) && _ctx.toArray(menu.menu_subs).length)
          ? (_openBlock(), _createBlock(_component_layout_auth_sidebar_content_submenu, {
              key: 0,
              menuSubs: menu.menu_subs,
              isOpen: _ctx.isOpenSubmenu[index]
            }, null, 8, ["menuSubs", "isOpen"]))
          : _createCommentVNode("", true)
      ]))
    }), 128))
  ]))
}